// Intro overlay shown the first time TC Mode is enabled — explains what the mode
// hides and lets the user dismiss it.

import React from 'react';

function TcModeOverlay({ isOpen = false, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
            <div className="relative w-full max-w-3xl rounded-xl bg-[color:var(--surface-primary)] p-8 shadow-2xl">
                <div className="absolute -top-12 left-1/2 hidden -translate-x-1/2 transform md:block">
                    <div className="rounded-full bg-[color:var(--color-accent)] px-5 py-2 text-sm font-semibold uppercase tracking-wide text-white shadow-lg">
                        Transaction Coordinator Mode
                    </div>
                </div>
                <h2 className="text-3xl font-bold text-[color:var(--text-primary)]" id="tc-mode-overlay-title">Welcome to TC Mode</h2>
                <p className="mt-3 text-sm text-[color:var(--text-muted)]">
                    This workspace is tailored for Transaction Coordinators. Financial tools are hidden so you can focus on
                    timelines, documents, and communication for every transaction.
                </p>

                <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
                    <div className="rounded-lg border border-[color:var(--border-color)] bg-[color:var(--surface-info)] p-5">
                        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-[color:var(--color-accent)]">
                            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[color:var(--color-accent)] text-white">1</span>
                            Dashboard Highlights
                        </h3>
                        <p className="mt-3 text-sm text-[color:var(--color-accent)]">
                            See upcoming transaction dates at a glance so you never miss a deadline. Key milestones appear
                            automatically when timelines are set.
                        </p>
                    </div>
                    <div className="rounded-lg border border-[color:var(--border-color)] bg-[color:var(--surface-info)] p-5">
                        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-[color:var(--color-accent)]">
                            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[color:var(--color-accent)] text-white">2</span>
                            Streamlined Transactions
                        </h3>
                        <p className="mt-3 text-sm text-[color:var(--color-accent)]">
                            Manage clients, property details, and milestones without financial inputs. Track progress using
                            statuses, notes, and due dates.
                        </p>
                    </div>
                    <div className="rounded-lg border border-[color:var(--border-color)] bg-[color:var(--surface-info)] p-5">
                        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-[color:var(--color-accent)]">
                            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[color:var(--color-accent)] text-white">3</span>
                            Communication Tools
                        </h3>
                        <p className="mt-3 text-sm text-[color:var(--color-accent)]">
                            Continue using shared templates, email composer, and vendor records to coordinate activity with
                            your Realtor partners.
                        </p>
                    </div>
                    <div className="rounded-lg border border-[color:var(--border-color)] bg-[color:var(--surface-info)] p-5">
                        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-[color:var(--color-accent)]">
                            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[color:var(--color-accent)] text-white">4</span>
                            Switch Anytime
                        </h3>
                        <p className="mt-3 text-sm text-[color:var(--color-accent)]">
                            Need the full financial suite? Disable TC Mode from Settings and KeyFlow CRM switches back to Realtor mode.
                        </p>
                    </div>
                </div>

                <div className="mt-8 text-right">
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex items-center rounded-md bg-[color:var(--color-accent)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:opacity-90"
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TcModeOverlay;
